import { render, staticRenderFns } from "./MessageDetailTable.vue?vue&type=template&id=57a795b6&scoped=true&"
import script from "./MessageDetailTable.vue?vue&type=script&lang=js&"
export * from "./MessageDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./MessageDetailTable.vue?vue&type=style&index=0&id=57a795b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a795b6",
  null
  
)

export default component.exports